// FETCH ALL PROPERTIES FROM STYLE_MASTER PAGE
export const FETCH_STYLE_MASTER_REQUEST = 'FETCH_STYLE_MASTER_REQUEST';
export const FETCH_STYLE_MASTER_SUCCESS = 'FETCH_STYLE_MASTER_SUCCESS';
export const FETCH_STYLE_MASTER_FAILURE = 'FETCH_STYLE_MASTER_FAILURE';

export const FETCH_STYLE_MASTER_DELETE_BY_ID_REQUEST = 'FETCH_STYLE_MASTER_DELETE_BY_ID_REQUEST';
export const FETCH_STYLE_MASTER_DELETE_BY_ID_SUCCESS = 'FETCH_STYLE_MASTER_DELETE_BY_ID_SUCCESS';
export const FETCH_STYLE_MASTER_DELETE_BY_ID_FAILURE = 'FETCH_STYLE_MASTER_DELETE_BY_ID_FAILURE';

// FETCH ALL PROPERTIES FROM STYLE_MASTER PAGE
export const FETCH_COPY_STYLE_MASTER_REQUEST = 'FETCH_COPY_STYLE_MASTER_REQUEST';
export const FETCH_COPY_STYLE_MASTER_SUCCESS = 'FETCH_COPY_STYLE_MASTER_SUCCESS';
export const FETCH_COPY_STYLE_MASTER_FAILURE = 'FETCH_COPY_STYLE_MASTER_FAILURE';

// FETCH ALL PROPERTIES FROM STYLE_MASTER PAGE
export const FETCH_COPY_STYLE_MASTER1_REQUEST = 'FETCH_COPY_STYLE_MASTER1_REQUEST';
export const FETCH_COPY_STYLE_MASTER1_SUCCESS = 'FETCH_COPY_STYLE_MASTER1_SUCCESS';
export const FETCH_COPY_STYLE_MASTER1_FAILURE = 'FETCH_COPY_STYLE_MASTER1_FAILURE';

export const FETCH_MULTI_COPY_STYLE_MASTER_REQUEST = 'FETCH_MULTI_COPY_STYLE_MASTER_REQUEST';
export const FETCH_MULTI_COPY_STYLE_MASTER_SUCCESS = 'FETCH_MULTI_COPY_STYLE_MASTER_SUCCESS';
export const FETCH_MULTI_COPY_STYLE_MASTER_FAILURE = 'FETCH_MULTI_COPY_STYLE_MASTER_FAILURE';

export const FETCH_MULTI_COPY_STYLE_COLOR_MASTER_REQUEST = 'FETCH_MULTI_COPY_STYLE_COLOR_MASTER_REQUEST';
export const FETCH_MULTI_COPY_STYLE_COLOR_MASTER_SUCCESS = 'FETCH_MULTI_COPY_STYLE_COLOR_MASTER_SUCCESS';
export const FETCH_MULTI_COPY_STYLE_COLOR_MASTER_FAILURE = 'FETCH_MULTI_COPY_STYLE_COLOR_MASTER_FAILURE';

export const CHECK_STITCHING_MEASUREMENT_BY_STYLE_REQUEST = 'CHECK_STITCHING_MEASUREMENT_BY_STYLE_REQUEST';
export const CHECK_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS = 'CHECK_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS';
export const CHECK_STITCHING_MEASUREMENT_BY_STYLE_FAILURE = 'CHECK_STITCHING_MEASUREMENT_BY_STYLE_FAILURE';

export const CREATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST = 'CREATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST';
export const CREATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS = 'CREATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS';
export const CREATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE = 'CREATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE';

export const UPDATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST = 'UPDATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST';
export const UPDATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS = 'UPDATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS';
export const UPDATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE = 'UPDATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM STYLE_MASTER PAGE
export const FETCH_STYLE_MASTER_BY_ID_REQUEST = 'FETCH_STYLE_MASTER_BY_ID_REQUEST';
export const FETCH_STYLE_MASTER_BY_ID_SUCCESS = 'FETCH_STYLE_MASTER_BY_ID_SUCCESS';
export const FETCH_STYLE_MASTER_BY_ID_FAILURE = 'FETCH_STYLE_MASTER_BY_ID_FAILURE';

export const FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_REQUEST = 'FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_REQUEST';
export const FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_SUCCESS = 'FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_SUCCESS';
export const FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_FAILURE = 'FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_FAILURE';

// CREATE PROPERTIES FOR STYLE_MASTER PAGE
export const CREATE_STYLE_MASTER_REQUEST = 'CREATE_STYLE_MASTER_REQUEST';
export const CREATE_STYLE_MASTER_SUCCESS = 'CREATE_STYLE_MASTER_SUCCESS';
export const CREATE_STYLE_MASTER_FAILURE = 'CREATE_STYLE_MASTER_FAILURE';

// CREATE PROPERTIES FOR STYLE_MASTER PAGE
export const CREATE_COPY_STYLE_MASTER_REQUEST = 'CREATE_COPY_STYLE_MASTER_REQUEST';
export const CREATE_COPY_STYLE_MASTER_SUCCESS = 'CREATE_COPY_STYLE_MASTER_SUCCESS';
export const CREATE_COPY_STYLE_MASTER_FAILURE = 'CREATE_COPY_STYLE_MASTER_FAILURE';

// CREATE PROPERTIES FOR COPY MASTER NEW OPTION
export const CREATE_COPY_STYLE_MASTER_NEW_OPTION_REQUEST = 'CREATE_COPY_STYLE_MASTER_NEW_OPTION_REQUEST';
export const CREATE_COPY_STYLE_MASTER_NEW_OPTION_SUCCESS = 'CREATE_COPY_STYLE_MASTER_NEW_OPTION_SUCCESS';
export const CREATE_COPY_STYLE_MASTER_NEW_OPTION_FAILURE = 'CREATE_COPY_STYLE_MASTER_NEW_OPTION_FAILURE';

export const CREATE_COPY_STYLE_MASTER_PART_REQUEST = 'CREATE_COPY_STYLE_MASTER_PART_REQUEST';
export const CREATE_COPY_STYLE_MASTER_PART_SUCCESS = 'CREATE_COPY_STYLE_MASTER_PART_SUCCESS';
export const CREATE_COPY_STYLE_MASTER_PART_FAILURE = 'CREATE_COPY_STYLE_MASTER_PART_FAILURE';

export const CREATE_COPY_STYLE_MASTER_PART1_REQUEST = 'CREATE_COPY_STYLE_MASTER_PART1_REQUEST';
export const CREATE_COPY_STYLE_MASTER_PART1_SUCCESS = 'CREATE_COPY_STYLE_MASTER_PART1_SUCCESS';
export const CREATE_COPY_STYLE_MASTER_PART1_FAILURE = 'CREATE_COPY_STYLE_MASTER_PART1_FAILURE';

export const COPY_STYLE_MASTER_ASSIGN_COLOR_REQUEST = 'COPY_STYLE_MASTER_ASSIGN_COLOR_REQUEST';
export const COPY_STYLE_MASTER_ASSIGN_COLOR_SUCCESS = 'COPY_STYLE_MASTER_ASSIGN_COLOR_SUCCESS';
export const COPY_STYLE_MASTER_ASSIGN_COLOR_FAILURE = 'COPY_STYLE_MASTER_ASSIGN_COLOR_FAILURE';

// UPDATE PROPERTIES FOR STYLE_MASTER PAGE
export const UPDATE_STYLE_MASTER_REQUEST = 'UPDATE_STYLE_MASTER_REQUEST';
export const UPDATE_STYLE_MASTER_SUCCESS = 'UPDATE_STYLE_MASTER_SUCCESS';
export const UPDATE_STYLE_MASTER_FAILURE = 'UPDATE_STYLE_MASTER_FAILURE';

// UPDATE PROPERTIES FOR STYLE_MASTER PAGE
export const UPDATE_COPY_STYLE_MASTER_REQUEST = 'UPDATE_COPY_STYLE_MASTER_REQUEST';
export const UPDATE_COPY_STYLE_MASTER_SUCCESS = 'UPDATE_COPY_STYLE_MASTER_SUCCESS';
export const UPDATE_COPY_STYLE_MASTER_FAILURE = 'UPDATE_COPY_STYLE_MASTER_FAILURE';

// FETCH SINGLE PROPERTY FOR STYLE_MASTER PAGE
export const FETCH_SINGLE_STYLE_MASTER_REQUEST = 'FETCH_SINGLE_STYLE_MASTER_REQUEST';
export const FETCH_SINGLE_STYLE_MASTER_SUCCESS = 'FETCH_SINGLE_STYLE_MASTER_SUCCESS';
export const FETCH_SINGLE_STYLE_MASTER_FAILURE = 'FETCH_SINGLE_STYLE_MASTER_FAILURE';

// DELETE PROPERTIES FOR STYLE_MASTER PAGE
export const DELETE_STYLE_MASTER_REQUEST = 'DELETE_STYLE_MASTER_REQUEST';
export const DELETE_STYLE_MASTER_SUCCESS = 'DELETE_STYLE_MASTER_SUCCESS';
export const DELETE_STYLE_MASTER_FAILURE = 'DELETE_STYLE_MASTER_FAILURE';

// DELETE PROPERTIES FOR STYLE_MASTER PAGE
export const DELETE_COPY_STYLE_MASTER_REQUEST = 'DELETE_COPY_STYLE_MASTER_REQUEST';
export const DELETE_COPY_STYLE_MASTER_SUCCESS = 'DELETE_COPY_STYLE_MASTER_SUCCESS';
export const DELETE_COPY_STYLE_MASTER_FAILURE = 'DELETE_COPY_STYLE_MASTER_FAILURE';

export const CREATE_USER_FORM_STYLE_MASTER = 'CREATE_USER_FORM_STYLE_MASTER';
export const CREATE_USER_FORM_COPY_STYLE_MASTER = 'CREATE_USER_FORM_COPY_STYLE_MASTER';
export const STYLE_MASTER_USERFORM_RESET = 'STYLE_MASTER_USERFORM_RESET';
export const COPY_STYLE_MASTER_USERFORM_RESET = 'COPY_STYLE_MASTER_USERFORM_RESET';
export const COPY_STYLE_MASTER_USERFORM_RESET2 = 'COPY_STYLE_MASTER_USERFORM_RESET2';
export const STYLE_MASTER_USERFORM_DROPDOWNLIST_RESET = 'STYLE_MASTER_USERFORM_DROPDOWNLIST_RESET';

// navigate to access info page
export const NAVIGATE_STYLE_MASTER = 'NAVIGATE_STYLE_MASTER';
export const NAVIGATE_STYLE_MASTER_MAIN = 'NAVIGATE_STYLE_MASTER_MAIN';
// navigate to access details page
export const NAVIGATE_STYLE_DETAILS = 'NAVIGATE_STYLE_DETAILS';

export const NAVIGATE_STYLE_PREPARATION = 'NAVIGATE_STYLE_PREPARATION';
export const RESET_DIA_RESPONSE = 'RESET_DIA_RESPONSE';
export const SET_COPY_MODAL_VAR = 'SET_COPY_MODAL_VAR';

//update Approval status btn
export const STYLE_MASTER_UPDATE_APPROVALSTATUS_REQUEST = 'STYLE_MASTER_UPDATE_APPROVALSTATUS_REQUEST';
export const STYLE_MASTER_UPDATE_APPROVALSTATUS_SUCCESS = 'STYLE_MASTER_UPDATE_APPROVALSTATUS_SUCCESS';
export const STYLE_MASTER_UPDATE_APPROVALSTATUS_FAILURE = 'STYLE_MASTER_UPDATE_APPROVALSTATUS_FAILURE';

export const SEND_VERIFY_OTP_USERFORM_REQUEST = 'SEND_VERIFY_OTP_USERFORM_REQUEST';
export const SEND_VERIFY_OTP_USERFORM_SUCCESS = 'SEND_VERIFY_OTP_USERFORM_SUCCESS';
export const SEND_VERIFY_OTP_USERFORM_FAILURE = 'SEND_VERIFY_OTP_USERFORM_FAILURE';



export const FILE_UPLOAD_DATA_REQUEST = 'FILE_UPLOAD_DATA_REQUEST';
export const FILE_UPLOAD_DATA_SUCCESS = 'FILE_UPLOAD_DATA_SUCCESS';
export const FILE_UPLOAD_DATA_FAILURE = 'FILE_UPLOAD_DATA_FAILURE';


export const SIZE_MEASUREMENT_POST_DATA_REQUEST = 'SIZE_MEASUREMENT_POST_DATA_REQUEST';
export const SIZE_MEASUREMENT_POST_DATA_SUCCESS = 'SIZE_MEASUREMENT_POST_DATA_SUCCESS';
export const SIZE_MEASUREMENT_POST_DATA_FAILURE = 'SIZE_MEASUREMENT_POST_DATA_FAILURE';



export const FILE_UPLOAD_DATA_GET_LIST_REQUEST = 'FILE_UPLOAD_DATA_GET_LIST_REQUEST';
export const FILE_UPLOAD_DATA_GET_LIST_SUCCESS = 'FILE_UPLOAD_DATA_GET_LIST_SUCCESS';
export const FILE_UPLOAD_DATA_GET_LIST_FAILURE = 'FILE_UPLOAD_DATA_GET_LIST_FAILURE';

export const NAVIGATE_SIZE_MEASUREMENTS_DETAILS = 'NAVIGATE_SIZE_MEASUREMENTS_DETAILS';

export const SET_RADIO_BUTTON_DATA_COPY_STYLE = 'SET_RADIO_BUTTON_DATA_COPY_STYLE';

export const RESET_UPLOAD_ID_GET = 'RESET_UPLOAD_ID_GET'

export const FETCH_COSTING_ACTIVE_ONLY_REQUEST = 'FETCH_COSTING_ACTIVE_ONLY_REQUEST';
export const FETCH_COSTING_ACTIVE_ONLY_SUCCESS = 'FETCH_COSTING_ACTIVE_ONLY_SUCCESS';
export const FETCH_COSTING_ACTIVE_ONLY_FAILURE = 'FETCH_COSTING_ACTIVE_ONLY_FAILURE';


